import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M315-195q-33 0-56-24-24-23-24-56v-550q0-32 24-56 23-23 56-23h430q32 0 56 23 23 24 23 56v550q0 33-23 56-24 24-56 24H315Zm0-80h430v-550H315v550ZM175-56q-32 0-56-23-23-24-23-56v-590q0-17 11-28 12-12 29-12t28 12q11 11 11 28v590h470q17 0 28 11 12 12 12 29t-12 28q-11 11-28 11H175Zm140-219v-550 550Z"/>',
  f: '<path d="M315-195q-33 0-56-24-24-23-24-56v-550q0-32 24-56 23-23 56-23h430q32 0 56 23 23 24 23 56v550q0 33-23 56-24 24-56 24H315ZM175-56q-32 0-56-23-23-24-23-56v-590q0-17 11-28 11-12 29-12 17 0 28 12 11 11 11 28v590h470q17 0 28 11 12 11 12 28t-12 29q-11 11-28 11H175Z"/>',
};

export default data;
